import httpClient from '../httpClient';

export async function getAllOrgInterTransfFin() {
  try {
    const response = await httpClient.get(`/api/orginter-transffinanceira`);

    // Verifica se response.data existe antes de acessar registros
    if (!response.data || !Array.isArray(response.data.registros)) {
      console.warn('API retornou um formato inesperado:', response.data);
      return [];
    }

    return response.data.registros;
  } catch (error) {
    console.error('Erro ao obter dados:', error);
    return []; // Retorna array vazio para evitar erros no .map()
  }
}

export async function getOrgInterTransfFin(id: string) {
  try {
    const response = await httpClient.get(
      `/api/orginter-transffinanceira/${id}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados: ' + error);
  }
}

export async function getTransfFinPorOrgInter(id: string) {
  try {
    const response = await httpClient.get(
      `/api/orginter-transffinanceira/orginter/${id}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados: ' + error);
  }
}
